import React, { useState } from "react";
import { useMountEffect } from "../../../hooks/LifeCycle";
import VoucherAutorizacion from "../components/VoucherAutorizacion";
import { connect } from "react-redux";

const VoucherScreen = (props) => {
  const [dataAutorizacion, setDataAutorizacion] = useState(null);

  const [procedimientos, setProcedimientos] = useState([]);

  const [numeroAutorizacion, setNumeroAutorizacion] = useState([]);

  const [isVoucherMatricial, setIsVoucherMatricial] = useState(false);

  useMountEffect(() => {
    const {
      dataAutorizacion,
      procedimientos,
      numeroAutorizacion,
      isMatricial,
    } = props.getVoucherData?.voucherDataInfo;

    setNumeroAutorizacion(numeroAutorizacion);

    setDataAutorizacion(dataAutorizacion);

    setProcedimientos(procedimientos);

    setIsVoucherMatricial(isMatricial);
  });

  return (
    <VoucherAutorizacion
      numeroAutorizacion={numeroAutorizacion}
      dataAutorizacion={dataAutorizacion}
      procedimientos={procedimientos}
      isVoucherMatricial={isVoucherMatricial}
    />
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  authUserLoading: state.auth.authUserLoading,
  authUserError: state.auth.authUserError,

  getVoucherData: state.voucher.getVoucherData,
  getVoucherLoading: state.voucher.getVoucherLoading,
  getVoucherError: state.voucher.getVoucherError,
});

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(VoucherScreen);
